<script setup lang="ts">
interface Props {
  id?: string
  width?: number
  grow?: boolean
  collapsible?: boolean
  side?: 'left' | 'right'
  resizable?: { min?: number; max?: number } | boolean
  class?: string
  ui?: Record<string, any>
}
const props = withDefaults(defineProps<Props>(), {
  grow: false,
  collapsible: false,
  side: 'left'
})

const isOpen = defineModel<boolean>({ default: true })

const panelStyle = computed(() => {
  if (props.grow) return {}
  return props.width ? { width: `${props.width}px`, minWidth: `${props.width}px` } : {}
})

const panelClasses = computed(() => [
  'flex flex-col border-gray-200',
  props.grow ? 'flex-1 min-w-0' : 'flex-shrink-0',
  props.side === 'right' ? 'border-l' : 'border-r',
  props.collapsible && !isOpen.value ? 'hidden lg:flex' : ''
])
</script>

<template>
  <aside
    :id="id"
    :style="panelStyle"
    class="bg-white overflow-hidden"
    :class="[panelClasses, $props.class]"
  >
    <slot />
  </aside>
</template>
